// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';

var _slicedToArray = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var _require2 = require('url'),
    URL = _require2.URL;

var debug = require('debug')('elasticsearch');

var Transport = require('./lib/Transport');

var Connection = require('./lib/Connection');

var _require3 = require('./lib/pool'),
    ConnectionPool = _require3.ConnectionPool,
    CloudConnectionPool = _require3.CloudConnectionPool;

var Serializer = require('./lib/Serializer');

var errors = require('./lib/errors');

var ConfigurationError = errors.ConfigurationError;
var kInitialOptions = Symbol('elasticsearchjs-initial-options');
var kChild = Symbol('elasticsearchjs-child');
var kExtensions = Symbol('elasticsearchjs-extensions');

var buildApi = require('./api');

var Client = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Client, _EventEmitter);

  function Client() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Client).call(this));

    if (opts.cloud) {
      var _opts$cloud = opts.cloud,
          id = _opts$cloud.id,
          username = _opts$cloud.username,
          password = _opts$cloud.password; // the cloud id is `cluster-name:base64encodedurl`
      // the url is a string divided by two '$', the first is the cloud url
      // the second the elasticsearch instance, the third the kibana instance

      var cloudUrls = Buffer.from(id.split(':')[1], 'base64').toString().split('$'); // TODO: remove username and password here in 8

      if (username && password) {
        opts.auth = Object.assign({}, opts.auth, {
          username: username,
          password: password
        });
      }

      opts.node = "https://".concat(cloudUrls[1], ".").concat(cloudUrls[0]); // Cloud has better performances with compression enabled
      // see https://github.com/elastic/elasticsearch-py/pull/704.
      // So unless the user specifies otherwise, we enable compression.

      if (opts.compression == null) opts.compression = 'gzip';
      if (opts.suggestCompression == null) opts.suggestCompression = true;

      if (opts.ssl == null || opts.ssl && opts.ssl.secureProtocol == null) {
        opts.ssl = opts.ssl || {};
        opts.ssl.secureProtocol = 'TLSv1_2_method';
      }
    }

    if (!opts.node && !opts.nodes) {
      throw new ConfigurationError('Missing node(s) option');
    }

    var checkAuth = getAuth(opts.node || opts.nodes);

    if (checkAuth && checkAuth.username && checkAuth.password) {
      opts.auth = Object.assign({}, opts.auth, {
        username: checkAuth.username,
        password: checkAuth.password
      });
    }

    var options = Object.assign({}, {
      Connection: Connection,
      Transport: Transport,
      Serializer: Serializer,
      ConnectionPool: opts.cloud ? CloudConnectionPool : ConnectionPool,
      maxRetries: 3,
      requestTimeout: 30000,
      pingTimeout: 3000,
      sniffInterval: false,
      sniffOnStart: false,
      sniffEndpoint: '_nodes/_all/http',
      sniffOnConnectionFault: false,
      resurrectStrategy: 'ping',
      suggestCompression: false,
      compression: false,
      ssl: null,
      agent: null,
      headers: {},
      nodeFilter: null,
      nodeSelector: 'round-robin',
      generateRequestId: null,
      name: 'elasticsearch-js',
      auth: null,
      opaqueIdPrefix: null
    }, opts);
    _this[kInitialOptions] = options;
    _this[kExtensions] = [];
    _this.name = options.name;
    _this.serializer = new options.Serializer();
    _this.connectionPool = new options.ConnectionPool({
      pingTimeout: options.pingTimeout,
      resurrectStrategy: options.resurrectStrategy,
      ssl: options.ssl,
      agent: options.agent,
      Connection: options.Connection,
      auth: options.auth,
      emit: _this.emit.bind(_assertThisInitialized(_assertThisInitialized(_this))),
      sniffEnabled: options.sniffInterval !== false || options.sniffOnStart !== false || options.sniffOnConnectionFault !== false
    }); // Add the connections before initialize the Transport

    if (opts[kChild] !== true) {
      _this.connectionPool.addConnection(options.node || options.nodes);
    }

    _this.transport = new options.Transport({
      emit: _this.emit.bind(_assertThisInitialized(_assertThisInitialized(_this))),
      connectionPool: _this.connectionPool,
      serializer: _this.serializer,
      maxRetries: options.maxRetries,
      requestTimeout: options.requestTimeout,
      sniffInterval: options.sniffInterval,
      sniffOnStart: options.sniffOnStart,
      sniffOnConnectionFault: options.sniffOnConnectionFault,
      sniffEndpoint: options.sniffEndpoint,
      suggestCompression: options.suggestCompression,
      compression: options.compression,
      headers: options.headers,
      nodeFilter: options.nodeFilter,
      nodeSelector: options.nodeSelector,
      generateRequestId: options.generateRequestId,
      name: options.name,
      opaqueIdPrefix: options.opaqueIdPrefix
    });
    var apis = buildApi({
      makeRequest: _this.transport.request.bind(_this.transport),
      result: {
        body: null,
        statusCode: null,
        headers: null,
        warnings: null
      },
      ConfigurationError: ConfigurationError
    });
    Object.keys(apis).forEach(function (api) {
      _this[api] = apis[api];
    });
    return _this;
  }

  _createClass(Client, [{
    key: "extend",
    value: function extend(name, opts, fn) {
      if (typeof opts === 'function') {
        fn = opts;
        opts = {};
      }

      var _name$split = name.split('.'),
          _name$split2 = _slicedToArray(_name$split, 2),
          namespace = _name$split2[0],
          method = _name$split2[1];

      if (method == null) {
        method = namespace;
        namespace = null;
      }

      if (namespace != null) {
        if (this[namespace] != null && this[namespace][method] != null && opts.force !== true) {
          throw new Error("The method \"".concat(method, "\" already exists on namespace \"").concat(namespace, "\""));
        }

        this[namespace] = this[namespace] || {};
        this[namespace][method] = fn({
          makeRequest: this.transport.request.bind(this.transport),
          result: {
            body: null,
            statusCode: null,
            headers: null,
            warnings: null
          },
          ConfigurationError: ConfigurationError
        });
      } else {
        if (this[method] != null && opts.force !== true) {
          throw new Error("The method \"".concat(method, "\" already exists"));
        }

        this[method] = fn({
          makeRequest: this.transport.request.bind(this.transport),
          result: {
            body: null,
            statusCode: null,
            headers: null,
            warnings: null
          },
          ConfigurationError: ConfigurationError
        });
      }

      this[kExtensions].push({
        name: name,
        opts: opts,
        fn: fn
      });
    }
  }, {
    key: "child",
    value: function child(opts) {
      // Merge the new options with the initial ones
      var initialOptions = Object.assign({}, this[kInitialOptions], opts); // Tell to the client that we are creating a child client

      initialOptions[kChild] = true;
      var client = new Client(initialOptions); // Reuse the same connection pool

      client.connectionPool = this.connectionPool;
      client.transport.connectionPool = this.connectionPool; // Share event listener

      var emitter = this.emit.bind(this);
      client.emit = emitter;
      client.connectionPool.emit = emitter;
      client.transport.emit = emitter;
      client.on = this.on.bind(this); // Add parent extensions

      this[kExtensions].forEach(function (_ref) {
        var name = _ref.name,
            opts = _ref.opts,
            fn = _ref.fn;
        client.extend(name, opts, fn);
      });
      return client;
    }
  }, {
    key: "close",
    value: function close(callback) {
      var _this2 = this;

      if (callback == null) {
        return new Promise(function (resolve, reject) {
          _this2.close(resolve);
        });
      }

      debug('Closing the client');
      this.connectionPool.empty(callback);
    }
  }]);

  return Client;
}(EventEmitter);

function getAuth(node) {
  if (Array.isArray(node)) {
    var _iterator = _createForOfIteratorHelper(node),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var url = _step.value;

        var _auth = getUsernameAndPassword(url);

        if (_auth.username !== '' && _auth.password !== '') {
          return _auth;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  }

  var auth = getUsernameAndPassword(node);

  if (auth.username !== '' && auth.password !== '') {
    return auth;
  }

  return null;

  function getUsernameAndPassword(node) {
    if (typeof node === 'string') {
      var _URL = new URL(node),
          username = _URL.username,
          password = _URL.password;

      return {
        username: decodeURIComponent(username),
        password: decodeURIComponent(password)
      };
    } else if (node.url instanceof URL) {
      return {
        username: decodeURIComponent(node.url.username),
        password: decodeURIComponent(node.url.password)
      };
    }
  }
}

var events = {
  RESPONSE: 'response',
  REQUEST: 'request',
  SNIFF: 'sniff',
  RESURRECT: 'resurrect'
};
module.exports = {
  Client: Client,
  Transport: Transport,
  ConnectionPool: ConnectionPool,
  Connection: Connection,
  Serializer: Serializer,
  events: events,
  errors: errors
};